import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { TableOptions } from "../../../../shared-kernel/components/Table";
import { createAdapterToPerson, createAdapterToPersonEndpoint, createAdapterToFieldPersonEndpoint } from "../adapters/people.adapter";
import { Person } from "../domain/Person.model";
import { appConfig } from "../../../../config";
import { createAdapterToFilterBackend } from "../../../../utilities/paramsAdapter";

const BASE_PEOPLE_URL = "/general/personas";
const BASE_PEOPLE_MUTATION_URL = "/general/persona";
export const BASE_EXPORT_URL = `${appConfig.API_NODE_URL}/general/personas/export`;

export const peopleApi = createApi({
  reducerPath: "peopleApi",
  baseQuery: fetchBaseQuery({
    baseUrl: appConfig.API_NODE_URL,
    prepareHeaders: (headers: Headers) => {
      const APP_TOKEN = "app_token";
      const token = localStorage.getItem(APP_TOKEN);

      if (token) {
        headers.set("authorization", `${token}`);
      }

      return headers;
    },
    credentials: "include",
  }),
  refetchOnMountOrArgChange: true,
  tagTypes: ["People", "Person"],
  endpoints: (builder) => ({
    getPerson: builder.query<Person, number | undefined>({
      query: (id) => `${BASE_PEOPLE_MUTATION_URL}/${id}`,
      transformResponse: (response: any) => {
        return createAdapterToPerson(response.Content);
      },
      providesTags: (_res, _err, id) => [{type: 'Person', id: id?.toString()}],
    }),
    getPeople: builder.query<any, void>({
      query: () => ({
        url: `${BASE_PEOPLE_URL}`,
      }),
      providesTags: ["People"],
      transformResponse: (response: any) => {
        const endpointResponse = response?.rows?.map((person: any) => createAdapterToPerson(person));
        return {
          data: endpointResponse,
          page: 1,
          total: response?.total,
        };
      },
    }),
    createPerson: builder.mutation<any, Person>({
      query: (data) => ({
        url: `${BASE_PEOPLE_MUTATION_URL}`,
        method: "POST",
        body: {
          "Content": createAdapterToPersonEndpoint(data)
        },
      }),
      invalidatesTags: (_res, _err, data: Person) => ["People", {type: 'Person', id: data?.id?.toString()}],
    }),
    updatePerson: builder.mutation<any, Person>({
      query: (data: Person) => ({
        url: `${BASE_PEOPLE_MUTATION_URL}`,
        method: "PUT",
        body: {
          "Content": createAdapterToPersonEndpoint(data)
        },
      }),
      invalidatesTags: (_res, _err, data: Person) => ["People", {type: 'Person', id: data?.id?.toString()}],
    }),
    deletePerson: builder.mutation<void, number>({
      query: (id) => ({
        url: `${BASE_PEOPLE_MUTATION_URL}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (_res, _err, id: number) => ["People", {type: 'Person', id: id?.toString()}],
    }),
  }),
});

export const {
  useGetPersonQuery,
  useGetPeopleQuery,
  useCreatePersonMutation,
  useUpdatePersonMutation,
  useDeletePersonMutation
} = peopleApi;
